export class ExtensibleFunction {
    constructor(f) {
        return Object.setPrototypeOf(f, this.constructor.prototype);
    }
}
//# sourceMappingURL=extensibleFunction.js.map